<script setup>
  import { onMounted } from 'vue'
  import { useMapUIStore } from "@/stores/MapUIStore";
  import { useProductStore } from "@/stores/ProductStore";
  import { useUserStore } from "@/stores/UserStore";
  import { useMapStore } from '@/stores/MapStore';
  import MapButton from '@/components/MapButton.vue';
  import Icon from '@/components/icons/Icon.vue';
  import useMapConfigurationGlobals from '@/composables/useMapConfigurationGlobals';

  const {
    $DRAWING_TOOLS,
    $MAP_FAVORITING,
  } = useMapConfigurationGlobals();  

  const mapUIStore = useMapUIStore();
  const productStore = useProductStore();
  const userStore = useUserStore();
  const mapStore = useMapStore();

  // TODO: Composable
  function emitEvent(event, detail = {}) {
    window.$EventBus.dispatchEvent(event, detail);
  }  

  function controlsClickHandler(e) {
    const clickedButton = e.target.closest('[data-action]');
    if (!clickedButton) return;

    const action = clickedButton.dataset.action;

    switch(action) {
      case 'zoom-in':
        emitEvent('map-ui-zoom-in');
        break;
      case 'zoom-out':
        emitEvent('map-ui-zoom-out');
        break;
      case 'save-map':
        handleSaveMap();
        break;
      case 'drawing-tools':
        handleDrawingTools();
        break;
    }
  }

  function handleDrawingTools() {
    mapUIStore.toggleDrawingTools();
  }

  async function handleSaveMap() {
    if (!userStore.currentProfileId) await userStore.getProfiles(true);

    emitEvent('map-ui-save-map', { profileId: userStore.currentProfileId });
  }

  async function handleMapSavedToProfile(e) {
    const { containerName, containerId } = e.detail;

    mapStore.state.name = containerName;
    mapStore.state.shortName = containerName;
    mapStore.state.id = containerId;

    await userStore.getProfiles(true);

    if (jwc) {
      jwc.toaster.toast({
        type: 'favorite',
        content: `<strong>${containerName}</strong> saved to profile <strong>${userStore.currentProfile.name}</strong>`,
      })
    }  
  }

  onMounted(() => window.$EventBus.addEventListener('cosmos-map-saved', handleMapSavedToProfile))
</script>

<template>

  <div @click.prevent="controlsClickHandler" class="map__controls jwx-map__controls--primary">

    <div v-if="$MAP_FAVORITING && !productStore.hasFeatureUpgrade(37)" class="jwx-map-block jwx-map-block--transparent-border">
      <ul class="jwx-map-block__content jwx-map-block__items">
        <li class="jwx-map-block__item">
          <MapButton
            data-action="save-map"
          >
            <Icon v-if="mapStore.state.id > 999 && mapStore.state.name !== 'Unsaved Map'" name="star-solid" class="jwx-map-button__icon" />  
            <Icon v-else name="star" class="jwx-map-button__icon" :data-attention="mapStore.state.id === 'unsaved'" />  
          </MapButton>
        </li>
      </ul>
    </div>

    <div 
      v-if="$DRAWING_TOOLS" 
      class="jwx-map-block jwx-map-block--transparent-border" 
    >
      <ul class="jwx-map-block__content jwx-map-block__items">
        <li class="jwx-map-block__item">
          <MapButton
            :class="{ 'selected': mapUIStore.showDrawingTools }"
            data-action="drawing-tools"
          >
            <Icon name="drawing-tools" class="jwx-map-button__icon" />  
          </MapButton>
        </li>
      </ul>
    </div>

    <div v-if="mapUIStore.showZoomControl" class="jwx-map-block jwx-map-block--transparent-border">
      <ul class="jwx-map-block__content jwx-map-block__items">
        <li class="jwx-map-block__item">
          <MapButton data-action="zoom-out">
            <Icon name="minus" class="jwx-map-button__icon" /> 
          </MapButton>
        </li>        
        <li class="jwx-map-block__item">
          <MapButton data-action="zoom-in">
            <Icon name="plus" class="jwx-map-button__icon" /> 
          </MapButton>
        </li>       
      </ul>
    </div>

  </div>

</template>